var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCircleEnd(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    stroke: "#D8D8D8",
    strokeWidth: 2,
    d: "M25.106 17.73c2.124 1.399 2.462 2.4 1.013 3.003-1.45.603-2.849.797-4.199.582-1.35-.216-2.461-.679-3.334-1.39-.874-.71-1.47-.085-1.787 1.874-.318 1.96-1.102 3.5-2.352 4.619-1.25 1.12-1.935.624-2.055-1.486-.119-2.11-.823-3.144-2.114-3.1-1.29.042-2.62-.27-3.99-.937-1.369-.668-1.647-1.712-.833-3.133.814-1.422 1.757-2.509 2.829-3.263 1.071-.753 1.33-1.82.774-3.197-.556-1.378-.417-2.39.417-3.036.833-.646 1.915-.485 3.245.484 1.33.97 2.263.28 2.799-2.067.536-2.347 1.042-2.24 1.518.323.477 2.562 1.171 3.596 2.085 3.1.913-.494 2.46-1.108 4.644-1.84s2.869-.173 2.055 1.68c-.814 1.851-1.668 3.261-2.56 4.23-.894.97-.279 2.154 1.845 3.553z",
    transform: "translate(-1144 -420) translate(792 236) translate(56 184) translate(296)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0H32V32H0z",
    transform: "translate(-1144 -420) translate(792 236) translate(56 184) translate(296)"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleEnd);
export default __webpack_public_path__ + "static/media/circle-end.483f40a6f3be3ae26a74f263de26867d.svg";
export { ForwardRef as ReactComponent };